<div class="add-vehicle-modal">
  <div mat-dialog-title>
    <div class="row">
      <div class="col-md-10">
        <h3>COPY EXISTING FEATURES</h3>
      </div>
      <div class="col-md-2">
        <span class="fa fa-close action-icons" (click)="close()"></span>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class=" row ">
      <mat-form-field class="col-md-6 ">
        <mat-label>Model</mat-label>
        <mat-select (selectionChange)="onModelChange($event) " [(ngModel)]="model">
          <mat-option *ngFor="let model of models " [value]="model.model ">
            {{model.model}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row ">
      <mat-form-field class="col-md-6 ">
        <mat-label>Year</mat-label>
        <mat-select (selectionChange)="onYearChange() " [(ngModel)]="year">
          <mat-option *ngFor="let year of years " [value]="year ">
            {{year}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf=features>
      <div class="row col-md-6 ">Features Available:</div>
      <div class="row">
        <div class="col-md-6">
          <div *ngFor="let feature of features ">
            <div *ngFor="let item of featuresList ">
              <div *ngIf="item.issueId==feature " class="control-list ">{{item.featureName}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions ">
    <span>
      <button class="btn btn-default" (click)="onSelect()">Ok</button>
    </span>
    <span class="ml-2">
      <button class="btn btn-secondary" (click)="onCancel()">cancel</button>
    </span>
  </div>
</div>